/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Cognos Analytics Home (C) Copyright IBM Corp. 2021, 2022
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

 define([
	'ca-content/content/content',
	'../../nls/StringResources',
	'react',
	'react-dom',
	'baglass/app/plugins/MenuActionInterface'
], (content, StringResources, React, ReactDOM, MenuActionInterface)  => {

	class PropertiesViewAction extends MenuActionInterface {
		constructor(options) {
			super(options);
		}

		/** 
		 * This is called from the context menus and ContextToolbar
		 */
		onSelectItem(context) { 
			if (context.target) {
				const activeObject = context.target && context.target.activeObject;
				const selectionObject = activeObject && (activeObject.targetSelectedContext || activeObject.aSelectedContext);
				const selectionId = selectionObject[0].id;
				const content = { selectionId:  selectionId, targetId: activeObject.aSelectedContext[0].id };
				this.glassContext = context && context.glassContext;
				this.glassContext.openAppView('properties', {
					content
				});
			}
		}

		/**
		 * called to determine if visible
		 */
		isItemVisible(options) {
			let selectedContext = this.getSelectedContext(options);
			if (!selectedContext || selectedContext.length > 1) {
				return false;
			}
			const ancestors = selectedContext.ancestors;
			let lastAncestor = ancestors && ancestors[ancestors.length - 1];
			if (lastAncestor && lastAncestor.permissions) {
				return lastAncestor.permissions.includes('traverse');
			}
			return true;
		}

		/**
		* Returns the context using the current targetSelectedCount
		* @param {*} context 
		*/
		getSelectedContext(context) {
			const activeObject = context && context.target && context.target.activeObject;
			const object = activeObject && (activeObject.targetSelectedContext || activeObject.aSelectedContext);
			if (Array.isArray(object)) {
				if (object.length === 1) {
					return object[0];
				} else {
					return null;
				}
			}
			return context;
		}
	}

	return PropertiesViewAction;
});